import { SVGInterface } from "../../interface";

const Globe = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.5228 6.47715 22 12 22C17.5203 21.9939 21.9939 17.5203 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM9.61292 19.6403C7.9861 17.332 7.22004 15.0927 7.04157 13H4.05389C4.44601 16.1446 6.66333 18.7228 9.61292 19.6403ZM4.0539 11H7.04516C7.07671 10.6437 7.12425 10.2929 7.18623 9.9481C7.58126 7.75019 8.55111 5.85552 9.59257 4.36607C6.65355 5.28892 4.44519 7.86219 4.0539 11ZM19.9301 13C19.5398 16.13 17.3411 18.699 14.4119 19.6275C15.4517 18.139 16.4193 16.2466 16.8138 14.0519C16.8757 13.7071 16.9233 13.3563 16.9548 13H19.9301ZM19.9301 11C19.5388 7.86226 17.3305 5.28903 14.3916 4.36613C16.0153 6.67213 16.7801 8.90924 16.9584 11H19.9301ZM14.8453 13.6981C14.4213 16.0572 13.1905 18.0569 12.008 19.4859C10.0955 17.1547 9.25406 14.9686 9.05062 13H14.9454C14.92 13.2369 14.8864 13.4697 14.8453 13.6981ZM11.992 4.5141C13.9045 6.84526 14.7459 9.03142 14.9494 11H9.05463C9.07996 10.7631 9.11363 10.5303 9.15469 10.3019C9.5787 7.94276 10.8095 5.94312 11.992 4.5141Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Globe;
